import React from 'react';
import CardTable from '../CardTable';
import styles from '../card.module.css';

/* Вкладка «Воен. специальности и УП» (п. 7 ТЗ).
   Колонка «Групп» — число учебных групп (не название группы). Колонка «Кафедры»
   перечисляет кафедры, за которыми закреплена та же специальность (включая
   текущую). ФГОС бывает и регистрационным номером, и обозначением поколения —
   выводится как есть. РУП и Кафедры — перечни через запятую целиком. */

const COLUMNS = [
  { key: 'specialty', title: 'Военная специальность', cell: row => row.specialty, className: styles.lead },
  { key: 'fgos', title: 'ФГОС', cell: row => row.education_standard },
  { key: 'rup', title: 'РУП', cell: row => row.curricula },
  { key: 'generation', title: 'Поколение', cell: row => row.generation },
  { key: 'groups', title: 'Групп', cell: row => row.groups_count, className: styles.mono },
  {
    key: 'direction',
    title: 'Направление подготовки (специальность)',
    cell: row => row.training_direction,
    className: styles.lead,
  },
  { key: 'cathedras', title: 'Кафедры', cell: row => row.cathedras },
];

const Specialties = ({ data }) => (
  <CardTable
    columns={COLUMNS}
    rows={data.items}
    rowKey={(row, index) => (row.id != null ? row.id : index)}
    counter={<>Всего записей: <b>{data.count}</b></>}
    emptyTitle="Военных специальностей нет"
    emptyText="За кафедрой не закреплено ни одной военной специальности"
  />
);

export default Specialties;
